import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '../views/Home.vue'
import Calls from '../views/Calls.vue'
import Call from '../views/Call.vue'
import CallV2 from '../views/Call-v2.vue'
import Customers from '../views/Customers.vue'
import Customer from '../views/Customer.vue'
import Reasons from '../views/Reasons.vue'
import Reason from '../views/Reason.vue'
import Users from '../views/Users.vue'
import User from '../views/User.vue'
import Login from '../views/Login.vue'
import Questionnaires from '../views/Questionnaires.vue'
import Questionnaire from '../views/Questionnaire.vue'
import Responses from '../views/Responses.vue'
import Response from '../views/Response.vue'
import Group from '../views/Group.vue'
import Groups from '../views/Groups.vue'
import Stats from '../views/Stats.vue'
import Prime from '../views/Prime.vue'
import Primes from '../views/Primes.vue'
import Store from '../store'
import tools from '../config';

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        name: "login",
        path: '/',
        component: Login,
    },
    {
        name: "calls",
        path: '/calls',
        component: Calls,
    },
    {
        name: "addcall",
        path: '/call/:action',
        component: Call
    },
    {
        name: "editcall/id",
        path: '/call/:id/:action',
        component: Call
    },
    {
        name: "addcall-v2",
        path: '/call-v2/:action',
        component: CallV2
    },
    {
        name: "editcall-v2/id",
        path: '/call-v2/:id/:action',
        component: CallV2
    },
    {
        name: "customers",
        path: '/customers',
        component: Customers
    },
    {
        name: "customer",
        path: '/customer',
        component: Customer
    },
    {
        name: "customer/id",
        path: '/customer/:id',
        component: Customer
    },
    {
        name: "reasons",
        path: '/reasons',
        component: Reasons
    },
    {
        name: "reason",
        path: '/reason',
        component: Reason
    },
    {
        name: "reason/id",
        path: '/reason/:id',
        component: Reason
    },
    {
        name: "users",
        path: '/users',
        component: Users
    },
    {
        name: "user",
        path: '/user',
        component: User
    },
    {
        name: "user/id",
        path: '/user/:id',
        component: User
    },
    {
        name: "user/id/primes",
        path: '/user/:id/primes',
        component: Primes
    },
    {
        name: "user/id/prime/month/year",
        path: '/user/:user_id/prime/:id',
        component: Prime
    },
    {
        name: "customer/id/questionnaire/id/response",
        path: '/customer/:customer_id/questionnaire/:questionnaire_id/response',
        component: Response
    },
    {
        name: "customer/id/questionnaire/id/response/id",
        path: '/customer/:customer_id/questionnaire/:questionnaire_id/response/:response_id',
        component: Response
    },
    {
        name: "customer/id/questionnaire/id/responses",
        path: '/customer/:customer_id/questionnaire/:questionnaire_id/responses',
        component: Responses
    },
    {
        name: "/id/questionnaires",
        path: '/customer/:customer_id/questionnaires',
        component: Questionnaires
    },
    {
        name: "/id/questionnaire",
        path: '/questionnaire/:questionnaire_id/:action',
        component: Questionnaire
    },
    {
        name: "/id/questionnaire",
        path: '/customer/:customer_id/questionnaire/:action',
        component: Questionnaire
    },
    {
        name: "questionnaire/id/response",
        path: '/questionnaire/:id/response',
        component: Questionnaire
    },
    {
        name: "customer/id/questionnaire/id/show",
        path: '/customer/:customer_id/questionnaire/:questionnaire_id/:action',
        component: Questionnaire
    },
    {
        name: "questionnaires",
        path: '/questionnaires',
        component: Questionnaires
    },
    {
        name: "user/groups",
        path: '/groups',
        component: Groups
    },
    {
        name: "user/group",
        path: '/group',
        component: Group
    },
    {
        name: "user/group/id",
        path: '/group/:id',
        component: Group
    },
    {
        name: "stats/show",
        path: '/stats/show',
        component: Stats
    },
    // {
    //   path: '/about',
    //   name: 'About',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    // }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

router.beforeEach((to, from, next) => {

    if (!Store.getters.isAuthenticated && Store.getters.getToken) {

        Store.dispatch("refreshToken")
            .then(() => {
                if(to.fullPath === "/"){
                    next("calls");
                }else {
                    next(to.fullPath);
                }
                // next("customer/1/questionnaire/2");
            }).catch(() => {
                Store.commit("deconnect");
            });
    }else{

        if (to.name !== 'login' && !Store.getters.isAuthenticated) {
            next({name: 'login'});
        } else {
            next();
        }
    }
});

export default router
